var exports = {
  "w": "RefSelectorPanels__jkvuDk",
};

module.exports = exports;
